import { JSX, useContext } from 'react';
import { DataTableContext } from '..';

export const TableCell = (props: { fieldKey: string; row: object; index: number }): JSX.Element | null => {
  const { tableProps } = useContext(DataTableContext);
  const { fieldRenderOverrides = {} } = tableProps;
  const { fieldKey, row, index } = props;
  let cellContent;

  if (fieldRenderOverrides[fieldKey]) {
    cellContent = fieldRenderOverrides[fieldKey]({ row, key: fieldKey, index });
  } else {
    cellContent = (row as { [key: string]: string })[fieldKey];
  }
  return <>{cellContent as React.ReactNode}</>;
};
